<template>
  <div>
    <table>
      <colgroup>
        <col width="8" />
        <col width="1" />
        <col width="2" />
      </colgroup>
      <thead>
        <tr>
          <th>제목</th>
          <th>문항 수</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="roomCBT in cbtList" :key="roomCBT.roomCBTId">
          <td>{{ roomCBT.cbtTitle }}</td>
          <td>{{ roomCBT.questionCnt }}</td>
          <td>
            <div class="flex justify-center items-center gap-1">
              <GrmBtn size="xs" @click="onSelectCBT(roomCBT)">상세보기</GrmBtn>
              <GrmBtn size="xs" color="red" @click="onDeleteCBT(roomCBT)">삭제</GrmBtn>
            </div>
          </td>
        </tr>
        <tr v-if="cbtList.length === 0">
          <td colspan="3">문제집이 없습니다.</td>
        </tr>
      </tbody>
    </table>

    <GrmPagination class="mt-3" :page-info="cbtListPageInfo" @paging="onChangePage" />
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import RoomCBTDetail from "@/components/Room/CBT/RoomCBTDetail.vue";
import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import GrmPagination from "@/components/Common/pagination/GrmPagination.vue";

export default {
  name: 'RoomCBTList',
  components: {
    GrmPagination,
    GrmBtn
  },
  computed: {
    ...mapState('cbt', [
      'cbtList',
      'cbtListPageInfo'
    ])
  },
  methods: {
    ...mapActions('cbt', [
      'getCBT',
      'deleteCBT',
      'getCBTList'
    ]),

    async onSelectCBT(roomCBT) {
      try {
        await this.getCBT({ cbtId: roomCBT.cbtId })
        this.$modal(RoomCBTDetail)
      } catch (e) {
        console.error(e)
        this.$alert(this.$t('roomCbt.alert.failedLoadCbt'))
      }
    },
    onDeleteCBT(roomCBT) {
      this.$confirm({
        text: this.$t('roomCbt.alert.removeCbt'),
        ok: async () => {
          await this.deleteCBT({
            cbtId: roomCBT.cbtId,
          })

          await this.getCBTList({
            roomId: this.$room.roomId,
            searchText: '',
            page: 1,
            size: 10
          })

          this.$alert(this.$t('roomCbt.alert.completeRemoveCbt'))
        }
      })
    },
    async onChangePage(page) {
      try {
        await this.getCBTList({
          roomId: this.$room.roomId,
          searchText: '',
          page: page,
          size: 10
        })
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  font-size: 13px;
  text-align: center;
  table-layout: fixed;
  border: 1px solid #ccc;
}
thead {
  tr {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
tbody {
  tr {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    &:first-child {
      border-top: none;
    }
  }
}
tr {
  height: 40px;
  white-space: nowrap;
}
th {
  padding: 0 12px;
  font-size: 13px;
  white-space: nowrap;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }
}
td {
  padding: 0 12px;
  font-size: 13px;
  white-space: nowrap;
  border-left: 1px solid #ccc;
  &:first-child {
    border-left: none;
  }
}
</style>